import { FC, useEffect, useState } from 'react';

type CountdownProps = {
  expiresAt: Date | string;
  expiredText?: string;
  className?: string;
};

const Countdown: FC<CountdownProps> = ({
  expiresAt,
  expiredText = 'Expired',
  className = 'text-red-500',
}) => {
  const computeRemaining = (): string => {
    const diff = new Date(expiresAt).getTime() - Date.now();
    if (diff <= 0) return expiredText;
    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
    if (minutes > 0) return `${minutes}m ${seconds}s`;
    return `${seconds}s`;
  };

  const [display, setDisplay] = useState<string>(computeRemaining());

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplay(computeRemaining());
    }, 1000);
    return () => clearInterval(interval);
  }, [expiresAt]);

  return <span className={className}>{display}</span>;
};

export default Countdown;
